package com.tedd.db

import kotlin.String

public data class App_preference(
  public val key: String,
  public val pref_value: String,
)
